import { useAuth } from '~/store/auth'
import { defineStore } from 'pinia'
import { track } from '~/utils/Amplitude'
import amplitude from 'amplitude-js'
import { OAuthErrorCode } from '~/static/enums/error-code'

interface LoginStore {
  email: string
  mailSent: boolean
  emailError: string
  lock_expiration_time: number
  code: string
  codeError: string
}

export const useLogin = defineStore('login', {
  state: (): LoginStore => {
    return {
      email: '',
      mailSent: false,
      emailError: '',
      lock_expiration_time: 0,
      code: '',
      codeError: '',
    }
  },
  actions: {
    async sendCode() {
      this.emailError = new Validator(this.email)
        .required('Необходимо заполнить адрес эл. почты')
        .isEmail('Проверьте адрес эл. почты')
        .allErrorsToString()

      if (this.emailError !== '') {
        return
      }

      interface SendCodeResponse {
        result: boolean
        lock_expiration_time: number
      }

      const { response, error } = await useApi<SendCodeResponse>('auth.sendOneTimePassword', {}, HttpMethod.POST, {
        email: this.email,
      })
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
      } else {
        this.mailSent = true
        this.lock_expiration_time = response.lock_expiration_time
        track('Email entered', {
          user_email: this.email,
        })
      }
    },
    async checkCode() {
      this.codeError = new Validator(this.code)
        .required('Проверьте код')
        .isNumeric('Проверьте код')
        .lengths([ 4 ], 'Проверьте код')
        .allErrorsToString()

      if (this.codeError !== '') {
        return
      }

      track('Email code entered', {
        user_email: this.email,
      })

      interface CheckCodeResponse {
        token: string
      }

      const { response, error } = await useApi<CheckCodeResponse>('auth.checkOneTimePassword', {}, HttpMethod.POST, {
        email: this.email,
        code: this.code,
      })
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
        this.codeError = 'Проверьте код'
        track('Email code error', {
          user_email: this.email,
        })
        return false
      } else {
        amplitude.getInstance().setUserProperties({ user_email: this.email })
        track('Email code right')
        const authStore = useAuth()
        await authStore.login(response.token)
        return true
      }
    },
    async loginByService(token: string) {
      interface LoginByServiceResponse {
        success: true
        token: string
      }

      interface LoginByServiceError {
        success: false
        error_code: OAuthErrorCode
      }

      const { response, error } = await useApi<LoginByServiceResponse | LoginByServiceError>(
        'auth.byService',
        {},
        HttpMethod.POST,
        { token },
      )
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
        return false
      } else if (!response.success) {
        return response.error_code
      } else {
        const authStore = useAuth()
        await authStore.login(response.token)
        return true
      }
    },
  },
})
